export default __webpack_public_path__ + "static/media/no-mentors.0055b70e.svg";